// Load the wallet for the individual's wallet tab.
import React, { useState } from "react";
import LoadingContent from "../../../components/LoadingContent.jsx";
import useIndividualWallet from "../../../functions/Firestore/useIndividualWallet.js";
import TransactionHistoryDialog from "../Dialogs/TransactionHistoryDialog.jsx";

export default function IndividualWalletTab({ userId, firstName, lastName }) {
  // Creates the user's wallet.
  const [communityWallet, setCommunityWallet] = useState({});
  const [loading, setLoading] = React.useState(true);
  // Loads the user's wallet.
  const error = useIndividualWallet(
    userId,
    firstName,
    lastName,
    setCommunityWallet,
    setLoading,
  );

  if (loading) {
    return (
      <div>
        <LoadingContent inline={true} />
      </div>
    );
  }
  if (error) {
    return (
      <div>
        <p>
          No wallet to display. Please contact
          anthony@farmtoplatemarketplace.com
        </p>
      </div>
    );
  }

  return (
    <div>
      <h2>Your F2PM Wallet</h2>
      <table border="1">
        <thead>
          <tr>
            <th></th>
            <th>Transaction History</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Balance</td>
            <td>
              <TransactionHistoryDialog
                buttonSize="small"
                balance={parseFloat(communityWallet.Total)}
                transactionHistory={communityWallet?.transactionHistory || []}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
